const CustomAxisTick = ({ x, y, payload, maxLength = 3 }) => {
  const truncateText = (text, maxLength) => {
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text
  }

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={16}
        textAnchor='middle'
        fill='#666'
        fontSize={'13px'}
        // transform="rotate(-35)"
      >
        <title>{payload?.value}</title> {/* Tooltip showing full text */}
        {truncateText(payload?.value || '', maxLength)}
      </text>
    </g>
  )
}

export default CustomAxisTick
